import React from "react";
import { getPages, getPagesCount } from "../../../_helpers/TablePaginationHelpers";

export function PaginationLinks({ paginationProps, disabled = false }) {
  const { totalSize, sizePerPage, page = 1, paginationSize = 5, onPageChange } = paginationProps;
  const pagesCount = Math.max(getPagesCount(totalSize, sizePerPage), 1);
  const currentPage = Math.max(Number(page) || 1, 1);
  const pages = getPages(Math.min(currentPage, pagesCount), pagesCount, paginationSize);
  const navigate = nextPage => {
    if (!disabled && nextPage >= 1 && nextPage <= pagesCount && nextPage !== currentPage) {
      onPageChange(nextPage);
    }
  };

  if (pagesCount < 2 && currentPage === 1) return null;

  return (
    <nav className="d-flex flex-wrap py-2 mr-3" aria-label="Páginas">
      <button
        type="button"
        onClick={() => navigate(1)}
        className="btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1"
        aria-label="Primera página"
        disabled={disabled || currentPage === 1}
      >
        <i className="ki ki-bold-double-arrow-back icon-xs" aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={() => navigate(Math.min(currentPage - 1, pagesCount))}
        className="btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1"
        aria-label="Página anterior"
        disabled={disabled || currentPage === 1}
      >
        <i className="ki ki-bold-arrow-back icon-xs" aria-hidden="true" />
      </button>

      {pages[0] > 1 && (
        <span className="btn btn-icon btn-sm border-0 mr-2 my-1" aria-hidden="true">…</span>
      )}
      {pages.map(p => (
        <button
          key={p}
          type="button"
          onClick={() => navigate(p)}
          className={`btn btn-icon btn-sm border-0 btn-light ${
            currentPage === p ? " btn-hover-primary active" : ""
          } mr-2 my-1`}
          aria-label={`Ir a página ${p}`}
          aria-current={currentPage === p ? "page" : undefined}
          disabled={disabled || currentPage === p}
        >
          {p}
        </button>
      ))}
      {pages[pages.length - 1] < pagesCount && (
        <span className="btn btn-icon btn-sm border-0 mr-2 my-1" aria-hidden="true">…</span>
      )}
      <button
        type="button"
        onClick={() => navigate(currentPage + 1)}
        className="btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1"
        aria-label="Página siguiente"
        disabled={disabled || currentPage >= pagesCount}
      >
        <i className="ki ki-bold-arrow-next icon-xs" aria-hidden="true" />
      </button>
      <button
        type="button"
        onClick={() => navigate(pagesCount)}
        className="btn btn-icon btn-sm btn-light btn-hover-primary mr-2 my-1"
        aria-label="Última página"
        disabled={disabled || currentPage === pagesCount}
      >
        <i className="ki ki-bold-double-arrow-next icon-xs" aria-hidden="true" />
      </button>
    </nav>
  );
}
